// Stats column mapping
export const statsColumnsMapping = {
    "name": 22,
    "damage": 0,
    "armor": 1,
    "health": 2,
    "strength": 3,
    "strengthPercentage": 4,
    "dexterity": 5,
    "dexterityPercentage": 6,
    "agility": 7,
    "agilityPercentage": 8,
    "constitution": 9,
    "constitutionPercentage": 10,
    "charisma": 11,
    "charismaPercentage": 12,
    "intelligence": 13,
    "intelligencePercentage": 14,
    "healing": 15,
    "criticalHealing": 16,
    "criticalAttack": 17,
    "blocking": 18,
    "hardening": 19,
    "threat": 20,
    "level": 21
};

// Helper function to sum stats from items
export const sumStat = (items, statIndex) => {
    return items
        .filter(Boolean)
        .reduce((sum, item) => {
            const value = Array.isArray(item) ? item[statIndex] : (item.stats ? item.stats[statIndex] : 0);
            return sum + (parseInt(value) || 0);
        }, 0);
};

// Helper function to format stat value as string
export const statAsString = (val, stat = "", multiplier = 1, name = "") => {
    if (stat === "level") {
        return name + " " + val;
    }

    let sign = val >= 0 ? "+" : "";
    return (name ? name + " " : "") + sign + (Math.floor(val * multiplier)) + (stat.match(/Percentage$/) ? "%" : "");
};

// Quality multipliers
export const qualityMultipliers = [1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2]; 